// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderButton":"SortIcon_tableHeaderButton__wBEY9","active":"SortIcon_active__3Neo2","sortArrowIcon":"SortIcon_sortArrowIcon__y7EP7"};